export const entrepreneurScheduledServicesStatus = [
  { label: "Asignado", value: "ASSIGNED" },
  { label: "Agendado", value: "SCHEDULED" },
  { label: "Entregado", value: "DELIVERED" },
  { label: "Aceptado por la Compañía", value: "ACCEPTED" }
];
